export default __webpack_public_path__ + "static/media/spaceship.12e28874.png";